<div class="block-container" *ngIf="value">
    <div class="title">
        <span class="date">{{value.onDate | date}}</span>
        <span class="interval">{{ value.interval | interval }}</span>
    </div>

    <div class="applied-state">
        <div class="state-title">
            <span>{{'SHARED.SLOT.BLOCK.APPLIEDSTATE' | translate}}</span>
            <i class="fa" [ngClass]="{'fa-lock': value.isBlocked, 'fa-unlock': !value.isBlocked}"
                aria-hidden="true"></i>
        </div>
    </div>

    <div class="divider"></div>

    <div class="system-state">
        <div class="state-subtitle">
            <span>{{'SHARED.SLOT.BLOCK.SYSTEM' | translate}}</span>
            <i class="fa" [ngClass]="{'fa-lock': value.isBlockedSystem, 'fa-unlock': !value.isBlockedSystem}"
                aria-hidden="true"></i>
        </div>
        <div class="state-text" [ngClass]="{'blocked': value.isBlockedSystem, 'unblocked': !value.isBlockedSystem}">
            {{value.isBlockedSystem ? ('SHARED.SLOT.BLOCK.WITHBLOCK' | translate) :
            ('SHARED.SLOT.BLOCK.WITHOUTBLOCK' | translate)}}
        </div>
    </div>

    <div class="user-state">
        <div class="state-subtitle">
            <span>{{'SHARED.SLOT.BLOCK.USER' | translate}}</span>
            <i class="fa" [ngClass]="{'fa-lock': isUserBlocked, 'fa-unlock': !isUserBlocked}" aria-hidden="true"></i>
        </div>
        <tristate [(ngModel)]="value.isBlockedUser" placeholder="{{'SHARED.SLOT.BLOCK.USER.PLACEHOLDER' | translate}}"
            [readonly]="readonly" (valueChanged)="onIsBlockedUserChanged($event)">
        </tristate>
    </div>

    <div class="tags-section">
        <div class="tags-help" [innerHTML]="'SHARED.SLOT.BLOCK.BLOCKTAGS.HELP' | translate"></div>
        <tags-chips [(ngModel)]="value.blockTags" name="blockTags"
            placeholder="{{ 'SHARED.SLOT.BLOCK.BLOCKTAGS.PLACEHOLDER' | translate }}" [readonly]="readonly"
            (valueChanged)="onBlockTagsChagend($event)">
        </tags-chips>
    </div>

    <div class="help-block" [innerHtml]="'SHARED.SLOT.BLOCK.HELP' | translate | safe:'html'"></div>
</div>